module Sm.UI.Interaction

open System
open MobF

open Sm.UI.Form
open Sm.UI.Form.Control

type Command =
    | TimerStart
    | TimerStop

type Editor =
    | Idle
    | Inline of Guid * TextInput.Type
    | Add of TextInput.Type

type State = {
    Selection: Guid option
    Editor: Editor
    Locked: bool
}

type Msg =
    | Select of Guid
    | ClearSelection
    | Input of Editor
    | EndInput
    | Lock
    | Release

type Computed =
    abstract SwitchInteraction: Button<Msg>

type Interaction = Model<State, Msg>

let create () =
    let init () =
        {
            Selection = None
            Editor = Idle
            Locked = false
        }

    let update (state, post) = function
        | Lock ->
            { state with Locked = true }

        | Release ->
            { state with Locked = false }

        | _ when state.Locked ->
            state

        | Select id ->
            post EndInput
            { state with Selection = Some id }

        | ClearSelection ->
            post EndInput
            { state with Selection = None }

        | Input editor ->
            { state with Editor = editor }

        | EndInput ->
            { state with Editor = Idle }

    Model.useInit init
    |> Model.andUpdateWithPost update
    |> Model.create
